import PropTypes from "prop-types";

const OverlayInstructions = ({ overlayInstructions = "", modifyScript = () => {}, toggleOff = () => {} }) => {
  return (
    <div
      id="recorder__instruction-view"
      style={{
        position: "absolute",
        backgroundColor: "rgba(0, 0, 0, 0.67)", 
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        zIndex: 1000, 
      }}
    >
      <div>
        <textarea
          onChange={modifyScript}
          className="overlay-instructions-textarea"
          style={{
            backgroundColor: "transparent",
            border: "none",
            outline: "none",
            color: "white",
            fontSize: "16px",
            fontWeight: "500",
            padding: "16px",
            resize: "none",
            width: "540px",
            // height: "100%",
            placeholderColor: 'white',
          }}
           placeholder="Click here to insert text"
        >
          {overlayInstructions}
        </textarea>
        {/* <button onClick={()=>{toggleOff()}}>Save</button> */}
      </div>
    </div>
  );
};

OverlayInstructions.propTypes = {
  overlayInstructions: PropTypes.string,
  modifyScript: PropTypes.func,
  toggleOff: PropTypes.func,
};

export default OverlayInstructions;
